import { Button, Typography } from '@sonnen/web-ui';
import { useAppContext } from '../../../AppContext/AppContext';
import { nextLabelByPath } from '../../../constants';
import { useCurrentRoute } from '../../../hooks/useCurrentRoute';
import { useOrderFlowNavigation } from '../../../hooks/useOrderFlowNavigation';
import { useTranslation } from '../../../i18n/i18n';
import { useOfferContext } from '../../../OfferContext/OfferContext';
import { DayAheadLabels } from '../../DayAheadLabels/DayAheadLabels';
import styles from './BatteryOptimizationCta.module.css';

export const BatteryOptimizationCta = () => {
  const { navigateNext } = useOrderFlowNavigation();
  const { confirmedDynamicTariff } = useAppContext().formValues;
  const { offer, offerLoading, offerError } = useOfferContext();
  const currentRoute = useCurrentRoute();
  const { t } = useTranslation();
  const nextLabel = t(nextLabelByPath[currentRoute] ?? 'offer.offerBtn');
  const batteryOptimizationConfiguration = offer?.batteryOptimization?.configuration;

  const nextButtonDisabled =
    !batteryOptimizationConfiguration || Boolean(offerError) || !confirmedDynamicTariff;

  return (
    <div data-testid="battery-optimization-cta">
      <div className={styles.batteryOptimizationCta}>
        <Typography.Body1>{t('offer.summaryCardTitle')}</Typography.Body1>
        <DayAheadLabels
          className={styles.value}
          configuration={batteryOptimizationConfiguration?.batteryOptimizationModule}
        />
      </div>

      <Button
        label={nextLabel}
        onClick={navigateNext}
        dataTestId="offer-card-mobile-btn"
        loading={offerLoading}
        expanded
        disabled={nextButtonDisabled}
      />
    </div>
  );
};
